module.exports = __webpack_public_path__ + "img/f88c92d605eb9ecda7b682bf80cd78ce.2ab087ac.png";